<template>
  <div class="product-info">

    <div class="banner" :style="`background-image: url(${bannerUrl})`">
      <div class="banner-content">
        <div class="banner-content-info">
          {{ $t('serviceSupport.productInfoPage.pageTitle') }}
          <span></span>
        </div>
      </div>
    </div>

    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/serviceSupport' }">{{ $t('serviceSupport.productInfoPage.breadcrumbService') }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t('serviceSupport.productInfoPage.breadcrumbProductInfo') }}</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="content-classify">
        <div class="content-classify-box">
          <div 
            class="classify-item" 
            :class="{'current': currentId === item.id}"
            v-for="item in tabList"
            :key="item.id"
            @click="tabsClick(item.id)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <servicesProduct1 v-if="currentId === 1"></servicesProduct1>
      <servicesProduct2 v-if="currentId === 2"></servicesProduct2>
      <servicesProduct3 v-if="currentId === 3"></servicesProduct3>
      <servicesProduct4 v-if="currentId === 4"></servicesProduct4>
  </div>
</template>

<script>
import servicesProduct1 from './components/servicesProduct1.vue';
import servicesProduct2 from './components/servicesProduct2.vue';
import servicesProduct3 from './components/servicesProduct3.vue';
import servicesProduct4 from './components/servicesProduct4.vue';
export default {
  data () {
    return {
      bannerUrl: require('@/assets/images/serviceSupport/productBanner1.png'),
      currentId: 1,
    }
  },
  computed: {
    title () {
      return this.$t('serviceSupport.productInfoPage.pageTitle')
    },
    tabList () {
      return this.$t('serviceSupport.productInfoPage.tabList')
    }
  },
  methods: {
    tabsClick (id) {
      this.currentId = id;
    }
  },
  components: {
    servicesProduct1,
    servicesProduct2,
    servicesProduct3,
    servicesProduct4
  }
}
</script>

<style scoped lang="scss">
.product-info {
  .el-breadcrumb {
    padding-top: 60px;
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 60px;
  }

  .content-classify {
    padding: 40px 0;
    background-color: rgb(249, 249, 249);
    .content-classify-box {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      .classify-item {
        padding: 14px 32px;
        border-radius: 30px;
        cursor: pointer;
        margin: 0 8px;
        background-color: rgb(240, 240, 240);
        &.current {
          background-color: rgb(28, 100, 215);
          color: #fff;
        }
      }
    }
  }

  .banner {
    height: 405px;
    display: block;
    margin: 0 auto;
    background-size: 1920px 570px;
    padding-top: 165px;
    .banner-content {
      width: 1200px;
      margin: 0 auto;
      .banner-content-info {
        width: 354px;
        height: 82px;
        border: 1px solid #fff;
        background: rgba(255, 255, 255, 0.2);
        backdrop-filter: blur(20px);
        font-weight: 600;
        font-size: 44px;
        color: #fff;
        padding: 70px 60px 80px;
        span {
          width: 80px;
          height: 4px;
          background: rgba(255, 255, 255, 1);
          display: block;
          margin-top: 16px;
        }
      }
    }
  }
  .title {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
  }
}
</style>
